
import Vue from "vue";
import Navbar from "./components/NavBar.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Snackbars from "./components/Snackbars.vue";
import axios, { AxiosError, AxiosResponse } from "axios";
import Wraxios from "./../services/Wraxios";
import {
  SetTranslationsPayload,
  Translations
} from "./../translations/Translations";
import { SnackbarBody, SnackbarColors } from "@./../../models/MiscTypes";
import { getQueryParam } from "./../services/SharedFunctions";
import { TranslationsResponse } from "./../models/TranslationTypes";
// @ts-ignore
import GlobalEvents from "vue-global-events";
import eventTracking from "./../services/EventTracking";

const wraxios = new Wraxios();

export default Vue.extend({
  components: {
    "nav-bar": Navbar,
    snackbars: Snackbars,
    "global-events": GlobalEvents
  },
  data() {
    return {
      languages: [] as { [key: string]: string }[],
      title: "MaintReq",
      eventTracking: eventTracking
    };
  },
  computed: {
    ...mapGetters({
      getSnackbars: "get_snackbars",
      language: "get_language",
      translations: "get_translations",
      showOverlay: "get_showOverlay"
    }),
    getTranslations(): Translations {
      return this.translations;
    },
    snackbars: {
      get(): Array<SnackbarBody> {
        return this.getSnackbars;
      },
      set(value) {
        this.setSnackbars(value);
      }
    }
  },
  beforeMount() {
    this.setOverlay(false);
    window.localStorage.removeItem("maintreq");
    this.onload();
  },
  methods: {
    ...mapActions({
      setDefaultText: "do_setDefaultText",
      showSnackbar: "do_showSnackbar"
    }),
    ...mapMutations({
      setSnackbars: "set_snackbars",
      setLanguage: "set_language",
      setOverlay: "set_showOverlay",
      setTranslations: "set_translations"
    }),
    async getTranslationsSuccess(response: AxiosResponse) {
      const translationsResponse = response.data as TranslationsResponse;
      const languages = [] as { [key: string]: string }[];

      Object.entries(translationsResponse.translationsData).forEach(
        async ([, value]) => {
          const payload = {
            langCode: value.langCode,
            translations: value.translation
          } as SetTranslationsPayload;

          this.setTranslations(payload);
          languages.push({
            text: value.languageName,
            value: value.langCode
          });
        }
      );

      this.languages = languages;
      this.setDefaultText(translationsResponse.defaultPhrases);
      this.title = translationsResponse.title;
      document.title = this.title;
    },
    getTranslationsFailure(error: AxiosError) {
      this.$nextTick(() => {
        this.showSnackbar({
          text:
            error.response?.data ||
            "There was a problem getting translations, so the app might not function properly. If you experience problems, please contact support.",
          color: SnackbarColors.error
        } as SnackbarBody);
      });
    },
    async onload() {
      const callbacks = {
        200: this.getTranslationsSuccess,
        400: this.getTranslationsFailure,
        500: this.getTranslationsFailure
      };
      let langCode = "";
      const langCodeParam = getQueryParam("langcode");
      let browserLang = navigator.language.substring(0, 2);

      browserLang =
        this.language && browserLang !== this.language
          ? this.language
          : browserLang;

      // langcode URL param takes precedence over browser-set langage. Fall
      // back to english if both are falsy.
      langCode = langCodeParam !== "" ? langCodeParam : browserLang;

      this.setLanguage(langCode);

      await wraxios.get(
        axios,
        `account/getTranslations?lang=${langCode}`,
        callbacks
      );
    }
  }
});
